import styled from "styled-components";
import { ReactComponent as Search } from "../../assets/search.svg";

const StyledInput = styled.input<{ isOpen: boolean }>`
  width: 100%;
  border: none;
  font-size: 1.25rem;
`;

// animation: ${(props) =>
//   props.isOpen
//     ? css`
//         ${inputSizeChange} .1s forwards
//       `
//     : ""};

type InputProps = {
  isOpen: boolean;
};

export const Input = ({ isOpen }: InputProps) => {
  return (
    <>
      <Search />
      <StyledInput isOpen={isOpen} />
    </>
  );
};
